// Spare Parts 메뉴/탭 접근 판정 (순수 함수). 메뉴(AdminLeftMenu)와 탭(SparePartsTabs)이 같은 규칙을 쓴다.
export const SPARE_PARTS_HQ_COMPANY_ID = 'RAY00001';
export const SPARE_PARTS_PERSONAL_ADMINID = 'jeongho.lee';

export function collectOrderableCompanyIds(groupList) {
    if (!Array.isArray(groupList)) return [];
    const ids = [];
    groupList.forEach((x, idx) => {
        if (!Array.isArray(x?.company)) {
            console.warn('[guard] spare parts group skipped', {
                handler: 'collectOrderableCompanyIds',
                target: x?.groupName ?? idx,
                reason: 'group.company is not an array',
            });
            return;
        }
        ids.push(...x.company);
    });
    return ids;
}

export function resolveSparePartsAccess({ user, isExternalDealer, orderableIds } = {}) {
    if (!user || isExternalDealer) return { isHQ: false, isDealer: false };
    const personal = user?.adminid === SPARE_PARTS_PERSONAL_ADMINID;
    return {
        isHQ: user?.companyId === SPARE_PARTS_HQ_COMPANY_ID || personal,
        isDealer: (Array.isArray(orderableIds) && orderableIds.includes(user?.companyId)) || personal,
    };
}

export function getSparePartsMenuLink(access) {
    if (access?.isHQ) return '/Admin/AdminSpareParts';
    if (access?.isDealer) return '/Admin/AdminSparePartsCompany';
    return null;
}

// 주문목록 링크는 app.js 경로("/Admin/AdminSparePartsOrderList/")와 슬래시 없이도 매칭된다.
export const SPARE_PARTS_TABS = {
    hq: [
        { key: 'parts', link: '/Admin/AdminSpareParts', labelKey: 'service.label.sparePartsManagement' },
        { key: 'orders', link: '/Admin/AdminSparePartsOrderListManager', labelKey: 'orderlist' },
        { key: 'out', link: '/Admin/AdminSparePartsOutList', labelKey: 'outboundhistory' },
    ],
    dealer: [
        { key: 'parts', link: '/Admin/AdminSparePartsCompany', labelKey: 'service.label.spareParts' },
        { key: 'orders', link: '/Admin/AdminSparePartsOrderList', labelKey: 'io.label.orders' },
    ],
};

export function getSparePartsTabs(group, access) {
    if (group !== 'hq' && group !== 'dealer') {
        console.warn('[guard] spare parts tabs skipped', {
            handler: 'getSparePartsTabs',
            target: group,
            reason: 'unknown tab group',
        });
        return [];
    }
    const tabs = [...SPARE_PARTS_TABS[group]];
    if (access?.isHQ && access?.isDealer) {
        const otherParts = SPARE_PARTS_TABS[group === 'hq' ? 'dealer' : 'hq'][0];
        tabs.push({ ...otherParts, key: 'other' });
    }
    return tabs;
}
